import { ExamRepository } from "repositories/ExamRepository";
import { Exam, Note } from "types/Exam";
import { AppThunk } from "../rootStore";
import {
  setCurrentExam,
  // setMinMaxFrames,//TODO: Remove it when is working withe the new ExamMLResult store
  setDetailsModalVisibility,
  setExamFrames,
  setLoading,
  setNotes,
  setRemoveModalVisibility,
} from "./examSlice";
import { addRequest, removeRequest } from "../LoadingStore/loadingSlice";
import { Requests } from "../../types/requests";
import { ExamNoteItem } from "pages/VideoReview/components/ExamNoteItem";

export const getExam =
  (id: string): AppThunk =>
  async (dispatch) => {
    try {
      const examRepository = ExamRepository.getInstance();

      dispatch(addRequest(Requests.getExam));
      const exam = await examRepository.getExam(id);

      if (exam.exam) {
        dispatch(
          setCurrentExam({
            ...exam.exam,
            examMLResult: exam.results ?? exam.exam.examMLResult,
            joint: exam.joint ?? exam.exam.joint,
          }),
        );
      } else {
        // @ts-ignore: Unreachable code error
        dispatch(setCurrentExam(exam || ({} as Exam)));
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(removeRequest(Requests.getExam));
    }
  };

export const createNote =
  (note: Omit<Note, "createdAt">): AppThunk =>
  async (dispatch, getState) => {
    try {
      const examRepository = ExamRepository.getInstance();
      const {
        exam: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          currentExam: { _id, notes, patientRegionId },
        },
      } = getState();

      dispatch(setLoading(true));
      const newNote = await examRepository.postNote({
        patientRegionId,
        examId: _id,
        note: note.title,
      });

      dispatch(setNotes([...notes, newNote]));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setDetailsModalVisibility(false));
    }
  };

export const editNote =
  (note: Note): AppThunk =>
  async (dispatch, getState) => {
    try {
      const examRepository = ExamRepository.getInstance();
      const {
        exam: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          currentExam: { _id, notes, patientRegionId },
        },
      } = getState();

      dispatch(setLoading(true));
      await examRepository.patchNote({
        patientRegionId,
        examId: _id,
        noteId: note._id,
        note: note.title,
      });
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setDetailsModalVisibility(false));
    }
  };

export const deleteNote =
  (noteId: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const examRepository = ExamRepository.getInstance();
      const {
        exam: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          currentExam: { _id, notes, patientRegionId },
        },
      } = getState();

      dispatch(setLoading(true));
      const removedNote = await examRepository.deleteNote({
        patientRegionId,
        examId: _id,
        noteId,
      });

      if (!removedNote) {
        throw new Error();
      }

      const updatedNotes = notes.filter((note) => note._id !== noteId);

      dispatch(setNotes(updatedNotes));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setRemoveModalVisibility(false));
    }
  };

export const getExamFrames =
  (examId = ""): AppThunk =>
  async (dispatch) => {
    try {
      const examRepository = ExamRepository.getInstance();

      dispatch(addRequest(Requests.getExamFrames));
      const frames = await examRepository.getExamFrames(examId);

      dispatch(setExamFrames(frames.items));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(removeRequest(Requests.getExamFrames));
    }
  };
